import { createContext, useContext } from "react";
import { LivecourseEditorController } from "./LivecourseEditorController";

export const LivecourseEditorControllerContext = createContext<LivecourseEditorController>(null as never);
export const useLivecourseEditorController = (): LivecourseEditorController =>
	useContext(LivecourseEditorControllerContext);
